import { Route, Routes } from "react-router-dom";
import PunchApprovalsPage from "./Page";
import PunchApprovalFormIndex from "./Form";

export default function index() {
    
    return (
     <Routes>
         
        <Route path="/" element={<PunchApprovalsPage />}>        
            <Route path="/punch-approvals" element={<PunchApprovalsPage />} />
            <Route path="/:id" element={<PunchApprovalFormIndex />} />
        </Route>
     </Routes>
    )
  }
  